import {Component, Inject} from '@angular/core';
import {DOCUMENT} from '@angular/common';

@Component({
    selector: 'acabim-user-redirect-admin',
    template: ``
})
export class RedirectAdminComponent  {

    constructor(@Inject(DOCUMENT) private document: any) {
        this.document.location.href = '/admin';
    }
}
